// extracted by mini-css-extract-plugin
module.exports = {"hasPadding":"page-wrapper-module--has-padding--2lMgM","noHero":"page-wrapper-module--no-hero--2ysGa"};